import { render, staticRenderFns } from "./MealOptionGroup.vue?vue&type=template&id=1c5ac22c&"
import script from "./MealOptionGroup.vue?vue&type=script&lang=js&"
export * from "./MealOptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports